<template>
  <v-card outlined>
    <template v-if="requirement.referenceRequirement.protocol.length">
      <v-card-title>
        {{ $t("user.referenceForm.title") }}
      </v-card-title>

      <v-card-text>
        <Markdown :value="$t('user.referenceForm.description')" />
      </v-card-text>

      <v-card-text>
        <ResponseList :responses="requirement.referenceRequirement.protocol" />
      </v-card-text>
    </template>

    <template v-if="displayResult">
      <v-card-title>
        {{ $t("user.referenceForm.result.title") }}
      </v-card-title>

      <v-simple-table>
        <template #default>
          <tbody>
            <tr>
              <td>
                {{ $t("user.referenceForm.result.description") }}
              </td>

              <td>
                <Markdown :value="requirement.referenceRequirement.result.description" />
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>

    <v-card-actions>
      <v-btn @click="reference" :loading="loading">
        {{ $t("user.referenceForm.useReference") }}
      </v-btn>

      <v-btn @click="dereference" :loading="loading">
        {{ $t("user.referenceForm.doNotUseReference") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import ResponseList from "@/components/Fund/ResponseList";
import ReferenceMinimalRequirementMutation from "@/gql/mutations/ReferenceMinimalRequirementMutation.gql";
import DereferenceMinimalRequirementMutation from "@/gql/mutations/DereferenceMinimalRequirementMutation.gql";
import ReferenceStepModelRequirementMutation from "@/gql/mutations/ReferenceStepModelRequirementMutation.gql";
import DereferenceStepModelRequirementMutation from "@/gql/mutations/DereferenceStepModelRequirementMutation.gql";

export default {
  components: {
    ResponseList,
  },

  props: {
    model: {
      type: String,
      default: "minimal",
    },

    requirement: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    result() {
      return this.requirement.referenceRequirement.result;
    },

    hasResult() {
      const { result } = this;

      return result.result !== null || result.points !== 0;
    },

    displayResult() {
      return this.hasResult && this.requirement.referenceRequirement.fund.auditPeriod.year !== new Date().getFullYear();
    },
  },

  methods: {
    async reference() {
      this.loading = true;

      this.$emit("reference");

      await this.$apollo.mutate({
        mutation:
          this.model === "minimal" ? ReferenceMinimalRequirementMutation : ReferenceStepModelRequirementMutation,
        variables: {
          id: this.requirement.id,
        },
      });

      this.loading = false;
    },

    async dereference() {
      this.loading = true;

      await this.$apollo.mutate({
        mutation:
          this.model === "minimal" ? DereferenceMinimalRequirementMutation : DereferenceStepModelRequirementMutation,
        variables: {
          id: this.requirement.id,
        },
      });

      this.loading = false;
    },
  },
};
</script>
